// Reason-for-change prompt: the backend answers 400 {code: "reason_required"} when an admin changes a protected
// field (LME, rates, GST…); the api interceptor asks here and retries with the reason in X-Change-Reason.
let _ask = null;
export const setReasonAsker = (fn) => { _ask = fn; };
export const askReason = (fields, message) => (_ask ? _ask(fields, message) : Promise.resolve(window.prompt(message || `Reason for changing ${(fields || []).join(", ")}:`) || null));
